(function() {
'use strict';

const TR = angular.module('TR');
TR.filter('relativeCurrency', function($filter) {
    return function(amount, relativeTo) {
        const diff = amount - relativeTo;
        return $filter('roundedCurrency')(diff);
    };
});
})();
